import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import Blog from './views/blog'
import About from './views/about'
import Home from './views/home'
import NotFound from './views/not-found'
import PrivacyPolicy from './views/privacypolicy'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={Blog} exact path="/blog" />
        <Route component={About} exact path="/about" />
        <Route component={PrivacyPolicy} exact path="/privacypolicy" />
        <Route component={Home} exact path="/" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
